__turbopack_context__.v({
  "circle": "styles-module-scss-module__HDoBca__circle",
  "circleSvg": "styles-module-scss-module__HDoBca__circleSvg",
  "cvCompositionContainer": "styles-module-scss-module__HDoBca__cvCompositionContainer",
  "doneIcon": "styles-module-scss-module__HDoBca__doneIcon",
  "pop-out": "styles-module-scss-module__HDoBca__pop-out",
  "popOut": "styles-module-scss-module__HDoBca__popOut",
  "rotate": "styles-module-scss-module__HDoBca__rotate",
});
